import { createSlice, PayloadAction } from "@reduxjs/toolkit";
interface FilterState {
	executiveSummaryAvailable: boolean;
	selectedChart: boolean;
	executiveSummary: any;
	loading: boolean;
	error: string | null;
	showChart: boolean;
	quantError: string | null | boolean;
	eroorMessage: string;
	errorCode: Number;
	selectedSegments: string[];
	selectedSegments___: string[];
	activeSegments: any[]; //selected segment
	masterDropDown: any[];
	openFilter: boolean;
	executiveChartsData: any;
	searchtext: string; // search text in chart panel
	chartPanelDropdown: string; // chart panel dropdown
	chartPanelQuestion: string; // chart panel dropdown
	filterArray: string[]; // filter array
	sectionsTotalQuestions: {
		[question: string]: number;
	};
	isCompareActive: boolean;
}

const initialState: FilterState = {
	executiveSummaryAvailable: false,
	selectedChart: false,
	executiveSummary: [],
	loading: false,
	error: null,
	showChart: true,
	eroorMessage: "",
	errorCode: 404,
	quantError: null,
	selectedSegments: [], // split by
	selectedSegments___: [], // split by
	activeSegments: [],
	masterDropDown: [],
	openFilter: false,
	searchtext: "",
	chartPanelDropdown: "",
	chartPanelQuestion: "",
	filterArray: [], // side drawer
	sectionsTotalQuestions: {},
	isCompareActive: false,
	executiveChartsData: null,
};

const executiveSummarySlice = createSlice({
	name: "executiveSummaryData",
	initialState: {
		executiveSummary: initialState,
	},
	reducers: {
		setExecutiveSummaryAvailable: (state, action: PayloadAction<boolean>) => {
			state.executiveSummary.executiveSummaryAvailable = action.payload;
		},
		toggleSelectedChart: (state, action) => {
			state.executiveSummary.selectedChart = Boolean(action.payload);
		},
		setExecutiveSummaryData: (state, action) => {
			state.executiveSummary.executiveSummary = action.payload;
		},
		setLoading: (state, action) => {
			state.executiveSummary.loading = Boolean(action.payload);
		},
		setError: (state, action) => {
			state.executiveSummary.error = action.payload;
		},
		setShowChart: (state, action) => {
			state.executiveSummary.showChart = Boolean(action.payload);
		},
		setQuantError: (state, action) => {
			state.executiveSummary.quantError = action.payload;
		},
		setErrorMessage: (state, action) => {
			state.executiveSummary.eroorMessage = action.payload;
		},
		setErrorCode: (state, action) => {
			state.executiveSummary.errorCode = Number(action.payload);
		},
		setSelectedSegments: (state, action) => {
			state.executiveSummary.selectedSegments = action.payload;
		},
		setSelectedSegments___: (state, action) => {
			state.executiveSummary.selectedSegments___ = action.payload;
		},
		setActiveSegments(state, action: PayloadAction<string[]>) {
			state.executiveSummary.activeSegments = action.payload;
		},
		setExecutiveChartsData: (state, action) => {
			state.executiveSummary.executiveChartsData = action.payload;
		},
		setFilterArray(state, action: PayloadAction<string[]>) {
			state.executiveSummary.filterArray = action.payload;
		},
		setIsCompareActive(state, action: PayloadAction<boolean>) {
			state.executiveSummary.isCompareActive = action.payload;
		},
	},
});

export const {
	setExecutiveSummaryAvailable,
	toggleSelectedChart,
	setExecutiveSummaryData,
	setLoading,
	setErrorCode,
	setError,
	setQuantError,
	setShowChart,
	setSelectedSegments,
	setSelectedSegments___,
	setActiveSegments,
	setExecutiveChartsData,
	setIsCompareActive,
	setFilterArray,
} = executiveSummarySlice.actions;

export default executiveSummarySlice.reducer;
